import type {ConnectionState} from "core/upload/connectionState";

/**
 * Which sentence the progress card says under its title while a hosted upload runs
 * (kitecorp/transferify-ui#1301, ui#3204):
 *
 * - while requests go through, the keep-open warning, because the page carries the upload; with the
 *   promise that a closed tab can be continued here only when this browser kept the upload, since only
 *   then is it true;
 * - while they fail, what the connection is doing instead: reconnecting, or waiting for a network.
 */
export type UploadNoteKey = "keepOpen" | "keepOpenContinuable" | "reconnecting" | "offline";

export function uploadNoteKey(connection: ConnectionState, continuable: boolean): UploadNoteKey {
	if (connection !== "connected") {
		return connection;
	}
	return continuable ? "keepOpenContinuable" : "keepOpen";
}

/**
 * The note the card's one polite live region speaks instead of the progress, or null to keep speaking the
 * progress. Only a connection in trouble is announced: the keep-open warning is on screen from the start and
 * never changes, so a screen reader meets it in the card's own text, while a dropped connection is news. One
 * live region rather than two, so the two never talk over each other.
 */
export function announcedNoteKey(connection: ConnectionState): UploadNoteKey | null {
	return connection === "connected" ? null : connection;
}
